import React from 'react'
import { Link } from "react-router-dom"

const TakeBackSidebarContent = ({
    takebackId,
    user,
    onOpenAlert
}) => {

    return (
        <li>
            <Link to="/#" className="has-arrow waves-effect">
            <i className="mdi mdi-keyboard-return" />
            <span>{"Take Back Configuration"}</span>
            </Link>
            {/* </div> */}
            <ul className="sub-menu" aria-expanded="false">
            <li>
                <Link to="/take-back">{"Overview"}</Link>
            </li>
            <li>
                {takebackId
                ? <Link to={`/take-back/${takebackId}/details`}>{"Details"}</Link>
                : <Link to={"/take-back/details/add"}>{"Details"}</Link>
                }
            </li>
            <li>
                {takebackId
                ? <Link to={`/take-back/${takebackId}/accepted-items`}>{"Accepted Items"}</Link>
                : <Link to="/take-back/details/add"
                    onClick={() => onOpenAlert("You can unlock this option by adding Take Back Details.", "danger")}
                    className="sidebar-option--disabled"
                >
                    <span >{"Accepted Items"}</span>
                    <i className="bx bx-lock-alt" />
                </Link>
                }
            </li>
            {user?.role === "RETAILER" || user?.role === "CHARITY" ? (
                <li>
                {takebackId
                    ? <Link to={`/take-back/${takebackId}/redeem-coupon`}>{"Redeem Coupon"}</Link>
                    : <Link to="/take-back/details/add"
                    onClick={() => onOpenAlert("You can unlock this option by adding Take Back Details.", "danger")}
                    className="sidebar-option--disabled"
                    >
                    <span >{"Redeem Coupon"}</span>
                    <i className="bx bx-lock-alt" />
                    </Link>
                }
                </li>
            ) : null}
            <li>
                {takebackId
                ? <Link to={`/take-back/${takebackId}/local-stores`}>{"Local Stores"}</Link>
                : <Link to="/take-back/details/add"
                    onClick={() => onOpenAlert("You can unlock this option by adding Take Back Details.", "danger")}
                    className="sidebar-option--disabled"
                >
                    <span>{"Local Stores"}</span>
                    <i className="bx bx-lock-alt" />
                </Link>
                }
            </li>
            <li>
                <Link to="/#" className="has-arrow waves-effect">
                <i className="mdi mdi-truck-outline" />
                <span>{"Delivery"}</span>
                </Link>
                <ul className="sub-menu" aria-expanded="false">
                <li>
                    {takebackId
                    ? <Link to={`/take-back/${takebackId}/return-address`}>{"Return Address"}</Link>
                    : <Link to="/take-back/details/add"
                        onClick={() => onOpenAlert("You can unlock this option by adding Take Back Details.", "danger")}
                        className="sidebar-option--disabled"
                    >
                        <span >{"Return Address"}</span>
                        <i className="bx bx-lock-alt" />
                    </Link>
                    }
                </li>
                <li>
                    {takebackId
                    ? <Link to={`/take-back/${takebackId}/carriers`}>{"Carriers"}</Link>
                    : <Link to="/take-back/details/add"
                        onClick={() => onOpenAlert("You can unlock this option by adding Take Back Details.", "danger")}
                        className="sidebar-option--disabled"
                    >
                        <span >{"Carriers"}</span>
                        <i className="bx bx-lock-alt" />
                    </Link>
                    }
                </li>
                </ul>
            </li>
            </ul>
      </li>
    )
}

export default TakeBackSidebarContent